import * as React from 'react';

import { cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { bookingsContainersQueryAtom } from '../../_graphql/queryBookingsContainers';

import {
  SelectableContainerType,
  SelectContainerType,
} from '~/shared/components/select-fields/SelectContainerType';
import { EntityComboBoxProps } from '~/shared/components/select-fields/types';

export const SelectContainerByBooking = ({
  bookingId,
  ...props
}: EntityComboBoxProps<SelectableContainerType> & {
  bookingId: string | null;
}) => {
  const params = React.useMemo(() => {
    if (!bookingId) return { ids: [] };
    return { ids: [bookingId] };
  }, [bookingId]);
  // Fetch booking to get container type IDs for filtering
  const bookingsAtom = React.useMemo(
    () =>
      bookingsContainersQueryAtom(() => ({
        variables: params,
        skip: !bookingId,
      })),
    [params],
  );

  const { data: selectedBookings } = useAtomValue(bookingsAtom);

  // Extract container type IDs from the booking's containers
  const containerTypeIds = React.useMemo(() => {
    if (!bookingId || !selectedBookings?.[0]?.containers) return undefined;

    const ids = selectedBookings[0].containers.map((c) => c.containerType.id);

    if (ids.length === 0) return undefined;

    return ids;
  }, [bookingId, selectedBookings]);

  return (
    <SelectContainerType
      {...props}
      ids={containerTypeIds}
      skipSearch={!bookingId || !containerTypeIds}
      className={cn('@SelectContainerByBooking', props.className)}
    />
  );
};
